import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, m as motion } from 'framer-motion';
import { XIcon, CircleCheckIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/purchaseNotifications';
const SHOW_DURATION = 5000;
const GAP_BETWEEN = 9000;
const FIRST_DELAY = 6000;
export function PurchaseNotifications() {
  const [started, setStarted] = useState(false);
  const [index, setIndex] = useState<number | null>(null);
  const dismissedRef = useRef(false);
  const orderRef = useRef<number[]>([]);

  // Only start the cycle once the visitor has scrolled past the hero.
  useEffect(() => {
    const hero = document.getElementById('top');
    if (!hero) {
      setStarted(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) setStarted(true);
    }, {
      threshold: 0,
      rootMargin: '-200px 0px 0px 0px'
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!started) return;
    let timer: ReturnType<typeof setTimeout>;
    const shuffleOrder = () => {
      const arr = purchaseNotifications.map((_, i) => i);
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      orderRef.current = arr;
    };
    const showNext = () => {
      if (orderRef.current.length === 0) shuffleOrder();
      const next = orderRef.current.shift();
      dismissedRef.current = false;
      setIndex(next ?? 0);
      timer = setTimeout(() => {
        if (!dismissedRef.current) setIndex(null);
        timer = setTimeout(showNext, GAP_BETWEEN);
      }, SHOW_DURATION);
    };
    timer = setTimeout(showNext, FIRST_DELAY);
    return () => clearTimeout(timer);
  }, [started]);
  const current = index !== null ? purchaseNotifications[index] : null;
  return <div className="pointer-events-none fixed bottom-24 left-4 z-30 md:bottom-6 md:left-6" data-id="element-236" data-mp="3j82gxcqmwk8b">
      <AnimatePresence data-id="element-237" data-mp="3krc63revsbzp">
        {current && <motion.div key={`${current.name}-${index}`} initial={{
        x: -24,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -24,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex max-w-[300px] items-start gap-3 rounded-xl border border-mp-border bg-mp-card/95 p-3.5 shadow-glow-blue backdrop-blur-sm" role="status" data-id="element-238" data-mp="3ppm2248fjgmd">
            <CircleCheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-mp-lime" strokeWidth={2} data-id="element-239" data-mp="36t49jklrbcp2" />
            <div className="min-w-0 flex-1" data-id="element-240" data-mp="2s0akp8klhk7q">
              <p className="text-xs leading-snug text-mp-white sm:text-sm" data-id="element-241" data-mp="2x0f0ewdoiaww">
                <span className="font-semibold" data-id="element-242" data-mp="2j1p8rw9mp3fx">{current.name}</span> desde {current.location} acaba de adquirir{' '}
                <span className="text-mp-lime" data-id="element-243" data-mp="2n3ag723e8piq">{current.product}</span>
              </p>
              <p className="mt-0.5 text-[11px] text-mp-gray" data-id="element-244" data-mp="24e8aybueaefk">{current.timeAgo}</p>
            </div>
            <button type="button" onClick={() => {
          dismissedRef.current = true;
          setIndex(null);
        }} aria-label="Cerrar notificación" className="flex-shrink-0 text-mp-gray transition-colors duration-150 hover:text-mp-white" data-id="element-245" data-mp="1zg6tfvcman67">
              <XIcon className="h-3.5 w-3.5" data-id="element-246" data-mp="2nc1engcuese0" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}